import {
    allFetch
} from "../Domain";


/**
 * @description 使用者
 */
export const User = (() => {
    /**
     * @description 使用者細項
     * @param {string} user_id 帳號編號
     * @returns res
     */
    const UserDetail = async (obj = {
        user_id: ''
    }) => {
        return await allFetch("User/UserDetail", obj);
    }
    /**
     * @description 使用者編輯
     * @param {string} user_id 帳號編號
     * @param {string} username 帳號
     * @param {string} name 姓名
     * @param {string} gender 性別
     * @param {string} birthday 生日
     * @param {string} telephone 電話
     * @param {string} mobile_phone 手機
     * @param {string} email 電子信箱
     * @param {string} city 城市(聯絡)
     * @param {string} area 區域(聯絡)
     * @param {string} address 住址(聯絡)
     * @param {string} city_census 城市(戶籍)
     * @param {string} area_census 區域(戶籍)
     * @param {string} address_census 住址(戶籍)
     * @param {string} on_board_date 到職日
     * @param {string} note 備註
     * @param {string} home_page 首頁
     * @param {string} blood_type 血型
     * @param {string} identity_card 身份證
     * @param {string} SMT_username SMT使用者帳號
     * @returns res
     */
    const UserUpdate = async (obj = {
        user_id: '',
        username: '',
        name: '',
        gender: '',
        birthday: '',
        telephone: '',
        mobile_phone: '',
        email: '',
        city: '',
        area: '',
        address: '',
        city_census: '',
        area_census: '',
        address_census: '',
        on_board_date: '',
        note: '',
        home_page: '',
        blood_type: '',
        identity_card: '',
        SMT_username: ''
    }) => {
        return await allFetch("User/UserUpdate", obj);
    }
    /**
     * @description 使用者職務職責異動紀錄查詢
     * @param {string} user_id 帳號編號
     * @param {string} date_start 日期起
     * @param {string} date_end 日期迄
     * @returns res
     */
    const UserLevelDutyHistorySearch = async (obj = {
        user_id: '',
        date_start: '',
        date_end: ''
    }) => {
        return await allFetch("User/UserLevelDutyHistorySearch", obj);
    }
    /**
     * @description 使用者職等職級異動紀錄查詢
     * @param {string} user_id 帳號編號
     * @param {string} date_start 日期起
     * @param {string} date_end 日期迄
     * @returns res
     */
    const UserCareerRankHistorySearch = async (obj = {
        user_id: '',
        date_start: '',
        date_end: ''
    }) => {
        return await allFetch("User/UserCareerRankHistorySearch", obj);
    }
    /**
     * @description 使用者修改職務     
     * @param {string} user_id 帳號編號
     * @param {string} ul_id 職務編號
     * @param {string} ucr_id 職等職級流水號
     * @param {string} career_level 職級
     */
    const UserUpdateLevel = async function (obj = {
        user_id: '',
        ul_id: '',
        ucr_id: '',
        career_level: ''
    }) {
        return await allFetch('User/UserUpdateLevel', obj);
    }
    const UserUpdateLevel_Info = async function () {
        return {
            api_name: "更新使用者職務",
            keys: [{
                key: "user_id",
                name: "帳號編號"
            },
            {
                key: "ul_id",
                name: "職務編號"
            },
            {
                key: "ucr_id",
                name: "職等職級流水號"
            },
            {
                key: "career_level",
                name: "職級"
            }
            ]
        }
    }
    /**
     * @description 使用者更新職責     
     * @param {string} user_id 帳號編號
     * @param {string} ud_ids 要給跟不給的職責編號
     */
    const UserUpdateDuty = async function (obj = {
        user_id: '',
        ud_ids: new Array()
    }) {
        return await allFetch('User/UserUpdateDuty', obj);
    }
    const UserUpdateDuty_Info = async function () {
        return {
            api_name: "更新使用者職責",
            keys: [{
                key: "user_id",
                name: "帳號編號"
            },
            {
                key: "ud_ids",
                name: "職責編號"
            }
            ]
        }
    }
    /**
     * @description 使用者修改職等職級     
     * @param {string} user_id 帳號編號
     * @param {string} ucr_id 職等職級流水號
     * @param {string} career_level 職級
     */
    const UserUpdateCareerRank = async function (obj = {
        user_id: '',
        ucr_id: '',
        career_level: ''
    }) {
        return await allFetch('User/UserUpdateCareerRank', obj);
    }
    const UserUpdateCareerRank_Info = async function () {
        return {
            api_name: "更新使用者職等",
            keys: [{
                key: "user_id",
                name: "帳號編號"
            },
            {
                key: "ucr_id",
                name: "職等職級流水號"
            },
            {
                key: "career_level",
                name: "職級"
            }
            ]
        }
    }

    /**
     * @description 使用者重設密碼  
     * @param {string} user_id 帳號編號
     * @param {string} new_password 密碼
     */
    const ResetPassword = async function (obj = {
        user_id: '',
        new_password: ''
    }) {
        return await allFetch('User/ResetPassword', obj);
    }
    /**
     * @description 使用者查詢(同職位&以下的) 
     */
    const UserSearch = async function (obj = {
        username: '',
        name: '',
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        ul_id: '',
        disable: '',
        has_ul_id: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('User/UserSearch', obj);
    }

    /**
     * @description 使用者查詢(選代理人用的，上層一層+同職務+下層全部**排除自己)
     */
    const UserSearchProxy = async function (obj = {
        user_id: ""
    }) {
        return await allFetch('User/UserSearchProxy', obj);
    }

    /**
     * @description 使用者查詢(還沒被分配職務的)
     */
    const UserSearchNoLevel = async function (obj = {
        username: '',
        name: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('User/UserSearchNoLevel', obj);
    }
    /**
     * @description 使用者查詢(還沒被分配職務的)
     */
    const UserCreate = async function (obj = {
        username: '',
        name: '',
        gender: '',
        birthday: '',
        telephone: '',
        mobile_phone: '',
        email: '',
        city: '',
        area: '',
        address: '',
        city_census: '',
        area_census: '',
        address_census: '',
        on_board_date: '',
        note: '',
        home_page: '',
        blood_type: '',
        identity_card: '',
        SMT_username: ''
    }) {
        return await allFetch('User/UserCreate', obj);
    }
    /**
     * @description 查詢使用者關係企業紀錄
     */
    const UserRelatedCompanyRecordSearch = async function (obj = {
        user_id: '',
        rcr_id: '',
        visible: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('User/UserRelatedCompanyRecordSearch', obj);
    }

    /**
     * @description 新增使用者關係企業紀錄
     */
    const UserRelatedCompanyRecordCreate = async function (obj = {
        user_id: '',
        name: '',
        date_start: '',
        date_end: ''
    }) {
        return await allFetch('User/UserRelatedCompanyRecordCreate', obj);
    }

    /**
     * @description 修改使用者關係企業紀錄
     */
    const UserRelatedCompanyRecordUpdate = async function (obj = {
        rcr_id: '',
        visible: ''
    }) {
        return await allFetch('User/UserRelatedCompanyRecordUpdate', obj);
    }



    /**
     * @description 使用者查詢(無視權限選所有在職的  請假選代理人用)
     */
    const UserSearchAll = async function (obj = {
        username: '',
        name: '',
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        ul_id: '',
        disable: '',
        page: 0,
        num_per_page: 10
    }) {
        let { username = "", name = "", company_id = "", general_manager_id = "", department_id = "", position_id = "", class_id = "", group_id = "", office_id = "", ul_id = "", disable = "", page = 0, num_per_page = 10, } = obj;
        return await allFetch('User/UserSearchAll', { username, name, company_id, general_manager_id, department_id, position_id, class_id, group_id, office_id, ul_id, disable, page, num_per_page })
            .then(async res => {
                if (res.success) return { ...res, data: res.data.map(item => ({ ...item, level_name: item.ul_name })) }
                else return res;
            });
    }

    /**
     * @description 使用者停用開放
     */
    const UserUpdateDisable = async function (obj = {
        user_id: '',
        disable: ''
    }) {
        return await allFetch('User/UserUpdateDisable', obj);
    }
    /**
     * @description 使用者離職
     */
    const UserResign = async function (obj = {
        user_id: '',
        resign_date: '',
        resign_reason: ''
    }) {
        return await allFetch('User/UserResign', obj);
    }

    return {
        UserDetail,
        UserUpdate,
        UserLevelDutyHistorySearch,
        UserCareerRankHistorySearch,
        UserUpdateLevel,
        UserUpdateLevel_Info,
        UserUpdateDuty,
        UserUpdateDuty_Info,
        UserUpdateCareerRank,
        UserUpdateCareerRank_Info,
        ResetPassword,
        UserSearch,
        UserSearchProxy,
        UserSearchNoLevel,
        UserCreate,
        UserRelatedCompanyRecordSearch,
        UserRelatedCompanyRecordCreate,
        UserRelatedCompanyRecordUpdate,
        UserSearchAll,
        UserUpdateDisable,
        UserResign
    }
})();